import React from 'react'
import styles from './styles.module.css'
import { Text } from 'src/comps/Atom/Text'

interface IBoardFilterProps {
  readonly value: string
  readonly children: React.ReactNode
  readonly icon: React.ReactNode
  readonly checked?: boolean
}

export default function BoardFilter({ value, children, icon, checked }: IBoardFilterProps) {
  return (
    <div>
      <input
        type="checkbox"
        value={value}
        id={`board-${value}`}
        className={styles.pillCheckbox}
        checked={checked}
      />
      <label htmlFor={`board-${value}`} className={styles.label}>
        {icon}
        <Text variant="textBodyM" weight="weight3">
          {children}
        </Text>
      </label>
    </div>
  )
}
